import { tickerItems } from "@/mocks/homeData";

export default function Ticker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section
      aria-label="材料整理说明"
      className="w-full overflow-hidden border-y border-background-200 bg-background-100 py-3.5"
    >
      <div className="flex w-max animate-marquee">
        {loopItems.map((item, index) => (
          <span
            key={`${item}-${index}`}
            className="flex items-center gap-3 px-6 font-label text-xs md:text-sm text-foreground-600 whitespace-nowrap"
          >
            <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500" aria-hidden="true"></i>
            {item}
          </span>
        ))}
      </div>
    </section>
  );
}